import './index.scss';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const Crumb = props => (
    <>
        {props.link !== '' ? <Link to={props.link}>{props.text}</Link> : <span>{props.text}</span>}
        {!props.last && <span> &gt; </span>}
    </>
);

Crumb.displayName = 'Crumb';
Crumb.propTypes = {
    last: PropTypes.bool,
    link: PropTypes.string,
    text: PropTypes.string
};

export default Crumb;
